import axios from 'axios';
import config from '@/config';



class Service {
  constructor() {
    let service = axios.create();
    this.service = service;
  }
  
  get(path, callback) {
    return this.service.get(config.url + path).then(
      (response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
              callback(error.message, null)
            }
      });
  }

  delete(path, callback) {
    return this.service.delete(config.url + path).then(
      (response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
              callback(error.message, null)
            }
      });
  }

  put(path, payload, callback) {
    return this.service.request({
      method: 'PUT',
      url: config.url + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
              callback(error.message, null)
            }
      });
  }

  post(path, payload, callback) {
    return this.service.request({
      method: 'POST',
      url: config.url + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error Last', error);
              callback(error.message, null)
            }
      });
  }

  postHeader(path, payload, callback) {
    return this.service.request({
      method: 'POST',
      url: config.url + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(null, response)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error Last', error);
              callback(error.message, null)
            }
      });
  }

  postNgrok(path, payload, callback) {
    return this.service.request({
      method: 'POST',
      url:  path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error Last', error);
              callback(error.message, null)
            }
      });
  }
}

export default new Service;
